// src/helper/validateEmail.js

export const validateEmail = (email) => {
    if (typeof email !== 'string') return false;

    const trimmedEmail = email.trim();

    // Check maximum email length
    if (trimmedEmail.length > 254) return false;

    // XSS check: Reject if email contains any HTML tags
    const xssRegex = /<[^>]*>/;
    if (xssRegex.test(trimmedEmail)) return false;

    // Simplified and practical email validation (covers >99% real cases)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!emailRegex.test(trimmedEmail)) return false;

    const emailLower = trimmedEmail.toLowerCase();
    const [localPart, domainPart] = emailLower.split('@');

    // Reject unwanted domain parts
    if (domainPart && domainPart.includes('rbcd')) return false;

    // Reject variations of "redbull"
    const invalidPattern = /red[\W_]*bull/i;
    if (invalidPattern.test(emailLower)) return false;

    return true;
};
